import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchError } from "./commonSlice";

const initialState = {
  list: [],
  perPage: "",
  total: 0,
  loading: false,
};

export const getServiceList = createAsyncThunk(
  "get-service",
  async (data, { dispatch }) => {
    try {
      const response = await axios.get("service/list", { params: data });
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const createService = createAsyncThunk(
  "create-service",
  async (data, { dispatch }) => {
    try {
      const response = await axios.post("service", data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const editService = createAsyncThunk(
  "edit-service",
  async (id, { dispatch }) => {
    try {
      const response = await axios.get(`service/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const updateService = createAsyncThunk(
  "update-service",
  async ({ id, data }, { dispatch }) => {
    try {
      const response = await axios.put(`/service/${id}`, data);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

export const deleteService = createAsyncThunk(
  "delete-service",
  async (id, { dispatch }) => {
    try {
      const response = await axios.delete(`/service/${id}`);
      return response;
    } catch (error) {
      dispatch(fetchError(error));
      return error;
    }
  }
);

const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getServiceList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getServiceList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action?.payload?.data?.data?.serviceList;
        state.perPage = action?.payload?.data?.data?.perPage;
        state.total = action?.payload?.data?.data?.total;
      })
      .addCase(getServiceList.rejected, (state, action) => {
        state.loading = false;
        state.list = "";
        state.perPage = "";
        state.total = "";
      });
  },
});

export default serviceSlice.reducer;
